export const imports = {
  'contributing.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "contributing" */ 'contributing.mdx'
    ),
  'index.mdx': () =>
    import(/* webpackPrefetch: true, webpackChunkName: "index" */ 'index.mdx'),
  'shared.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "shared" */ 'shared.mdx'
    ),
  'boolean/src/BooleanEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "boolean-src-boolean-editor" */ 'boolean/src/BooleanEditor.mdx'
    ),
  'checkbox/src/CheckboxEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "checkbox-src-checkbox-editor" */ 'checkbox/src/CheckboxEditor.mdx'
    ),
  'date/src/DateEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "date-src-date-editor" */ 'date/src/DateEditor.mdx'
    ),
  'default-field-editors/src/DefaultFieldEditors.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "default-field-editors-src-default-field-editors" */ 'default-field-editors/src/DefaultFieldEditors.mdx'
    ),
  'dropdown/src/DropdownEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "dropdown-src-dropdown-editor" */ 'dropdown/src/DropdownEditor.mdx'
    ),
  'json/src/JsonEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "json-src-json-editor" */ 'json/src/JsonEditor.mdx'
    ),
  'list/src/ListEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "list-src-list-editor" */ 'list/src/ListEditor.mdx'
    ),
  'location/src/LocationEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "location-src-location-editor" */ 'location/src/LocationEditor.mdx'
    ),
  'markdown/src/MarkdownEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "markdown-src-markdown-editor" */ 'markdown/src/MarkdownEditor.mdx'
    ),
  'multiple-line/src/MultipleLineEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "multiple-line-src-multiple-line-editor" */ 'multiple-line/src/MultipleLineEditor.mdx'
    ),
  'number/src/NumberEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "number-src-number-editor" */ 'number/src/NumberEditor.mdx'
    ),
  'radio/src/RadioEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "radio-src-radio-editor" */ 'radio/src/RadioEditor.mdx'
    ),
  'rating/src/RatingEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "rating-src-rating-editor" */ 'rating/src/RatingEditor.mdx'
    ),
  'rich-text/src/RichTextEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "rich-text-src-rich-text-editor" */ 'rich-text/src/RichTextEditor.mdx'
    ),
  'single-line/src/SingleLineEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "single-line-src-single-line-editor" */ 'single-line/src/SingleLineEditor.mdx'
    ),
  'slug/src/SlugEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slug-src-slug-editor" */ 'slug/src/SlugEditor.mdx'
    ),
  'tags/src/TagsEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tags-src-tags-editor" */ 'tags/src/TagsEditor.mdx'
    ),
  'url/src/UrlEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "url-src-url-editor" */ 'url/src/UrlEditor.mdx'
    ),
  'reference/src/assets/MultipleMediaEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "reference-src-assets-multiple-media-editor" */ 'reference/src/assets/MultipleMediaEditor.mdx'
    ),
  'reference/src/assets/SingleMediaEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "reference-src-assets-single-media-editor" */ 'reference/src/assets/SingleMediaEditor.mdx'
    ),
  'reference/src/entries/MultipleEntryReferenceEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "reference-src-entries-multiple-entry-reference-editor" */ 'reference/src/entries/MultipleEntryReferenceEditor.mdx'
    ),
  'reference/src/entries/SingleEntryReferenceEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "reference-src-entries-single-entry-reference-editor" */ 'reference/src/entries/SingleEntryReferenceEditor.mdx'
    ),
}
